import { combineReducers } from "redux";
import errorReducer from "./errorReducer";
import authReducer from "./authReducer";
import bindReducer from "./bindReducer";
import gameReducer from "./gameReducer";
import memberReducer from "./memberReducer";

export default combineReducers({
  errors: errorReducer,
  auth: authReducer,
  bind: bindReducer,
  games: gameReducer,
  member: memberReducer,
});
